module.exports = __webpack_public_path__ + "static/img/9.760bc36.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting596/images/9.png
// module id = l8Jb
// module chunks = 4